import React, { type FC } from 'react'

import { useRecoilValue } from 'recoil'

import { GRID_VARIANT_SMALL, Grid, GridCell } from 'mailup-web-components'

import {
  isTextMatchOperatorMultipleValue,
  isTextMatchOperatorSingleValue,
} from 'Pages/RecipientsList/model'

import InputCritType from 'Pages/RecipientsList/components/filters/InputCritType'
import InputIdentifier from 'Pages/RecipientsList/components/filters/anagraphicField/InputIdentifier'
import InputTextMatchOperator from 'Pages/RecipientsList/components/filters/anagraphicField/InputTextMatchOperator'
import InputValue from 'Pages/RecipientsList/components/filters/anagraphicField/InputValue'
import InputValues from 'Pages/RecipientsList/components/filters/anagraphicField/InputValues'

import ActionDeleteCriterion from 'Pages/RecipientsList/components/filters/ActionDeleteCriterion'

import {
  anagraphicFieldMatchOperatorState,
  identifierState,
} from 'Pages/RecipientsList/recoil/state/filters'

interface CriterionAnagraphicFieldProps {
  index: number
}

const CriterionAnagraphicField: FC<CriterionAnagraphicFieldProps> = ({
  index,
}) => {
  const identifier = useRecoilValue(identifierState(index))
  const matchOperator = useRecoilValue(anagraphicFieldMatchOperatorState(index))

  const isSingleValue = isTextMatchOperatorSingleValue(matchOperator)
  const isMultiValue = isTextMatchOperatorMultipleValue(matchOperator)

  return (
    <Grid variant={GRID_VARIANT_SMALL} cols={12}>
      <GridCell span={3}>
        <InputCritType index={index} />
      </GridCell>

      <GridCell span={2}>
        <InputIdentifier index={index} />
      </GridCell>

      {identifier !== undefined && (
        <>
          <GridCell span={2}>
            <InputTextMatchOperator index={index} />
          </GridCell>

          {isSingleValue && (
            <GridCell span={4}>
              <InputValue index={index} />
            </GridCell>
          )}

          {isMultiValue && (
            <GridCell span={4}>
              <InputValues index={index} />
            </GridCell>
          )}
        </>
      )}

      <GridCell span={1}>
        <ActionDeleteCriterion index={index} />
      </GridCell>
    </Grid>
  )
}

export default CriterionAnagraphicField
